import React from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';
import { MOBILE_REGEX } from '../../../utils/Constants';
import { LabelMedium } from '../../common/GlobalElements/Typography';
import CopyableField from '../../library/CopyableField';
import { tokens } from '../../../public/tokens';

const Required = styled.span({
    color: tokens.colors.states.alert['500'],
    fontFamily: tokens.globals['font-family'],
    fontSize: tokens.typography.fontSize['lg-14px'],
    fontWeight: tokens.typography.fontWeights.bold,
});

export const emergencyContactValidationSchema = {
    emergency_contact_name_one: Yup.string().required('Emergency Contact Name 1 is required'),
    emergency_contact_no_one: Yup.string()
        .matches(MOBILE_REGEX, 'Phone number should be 0-9 of 10 digits with country code')
        .required('Emergency Contact Number 1 is required'),
    emergency_contact_name_two: Yup.string(),
    emergency_contact_no_two: Yup.string().matches(
        MOBILE_REGEX,
        'Phone number should be 0-9 of 10 digits with country code',
    ),
    medical_aid: Yup.string(),
    medical_aid_number: Yup.string(),
};

/**
 * Emergency contact and medical aid fields, shared by the Profile page and
 * the required-student-details onboarding page.
 */
function EmergencyContactFields({ formik }) {
    const { values, errors, touched, handleChange, handleBlur } = formik;

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group" title="Emergency Contact Name 1">
                        <LabelMedium>
                            Emergency Contact Name 1<Required>*</Required>
                        </LabelMedium>
                        <input
                            type="text"
                            className={
                                'form-control' +
                                (errors.emergency_contact_name_one && touched.emergency_contact_name_one
                                    ? ' is-invalid'
                                    : '')
                            }
                            name="emergency_contact_name_one"
                            placeholder="Enter First Name"
                            value={values.emergency_contact_name_one}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group" title="Emergency Contact Number 1">
                        <LabelMedium>
                            Emergency Contact Number 1<Required>*</Required>
                        </LabelMedium>
                        <CopyableField
                            textToCopy={values.emergency_contact_no_one}
                            enableCopy={!(errors.emergency_contact_no_one && touched.emergency_contact_no_one)}
                        >
                            <input
                                type="text"
                                className={
                                    'form-control' +
                                    (errors.emergency_contact_no_one && touched.emergency_contact_no_one
                                        ? ' is-invalid'
                                        : '')
                                }
                                name="emergency_contact_no_one"
                                title="Emergency Contact Number 1"
                                placeholder="+27"
                                value={values.emergency_contact_no_one}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </CopyableField>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group" title="Emergency Contact Name 2">
                        <LabelMedium>Emergency Contact Name 2</LabelMedium>
                        <input
                            type="text"
                            className={
                                'form-control' +
                                (errors.emergency_contact_name_two && touched.emergency_contact_name_two
                                    ? ' is-invalid'
                                    : '')
                            }
                            name="emergency_contact_name_two"
                            placeholder="Enter First Name"
                            value={values.emergency_contact_name_two}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group" title="Emergency Contact Number 2">
                        <LabelMedium>Emergency Contact Number 2</LabelMedium>
                        <CopyableField
                            textToCopy={values.emergency_contact_no_two}
                            enableCopy={!(errors.emergency_contact_no_two && touched.emergency_contact_no_two)}
                        >
                            <input
                                type="text"
                                className={
                                    'form-control' +
                                    (errors.emergency_contact_no_two && touched.emergency_contact_no_two
                                        ? ' is-invalid'
                                        : '')
                                }
                                name="emergency_contact_no_two"
                                title="Emergency Contact Number 2"
                                placeholder="+27"
                                value={values.emergency_contact_no_two}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </CopyableField>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group" title="Medical Aid Provider">
                        <LabelMedium>Medical Aid Provider</LabelMedium>
                        <input
                            type="text"
                            className={
                                'form-control' + (errors.medical_aid && touched.medical_aid ? ' is-invalid' : '')
                            }
                            name="medical_aid"
                            placeholder="Enter Medical Aid Provider"
                            value={values.medical_aid}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group" title="Medical Aid Number and Code">
                        <LabelMedium>Medical Aid Number and Code</LabelMedium>
                        <input
                            type="text"
                            className={
                                'form-control' +
                                (errors.medical_aid_number && touched.medical_aid_number ? ' is-invalid' : '')
                            }
                            name="medical_aid_number"
                            title="Medical Aid Number and Code"
                            placeholder="(e.g. 123456789 - 01)"
                            value={values.medical_aid_number}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmergencyContactFields;
